import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-link"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      x: "0",
      class: "icon-fi--no-fill icon-fi--filled"
    }, null, -1),
    _createElementVNode("g", {
      transform: "translate(10.25 9.501)",
      class: ""
    }, [
      _createElementVNode("path", {
        d: "M9.4,18.5l-0.9,0.9c-1.8,1.8-4.6,1.8-6.4,0s-1.8-4.6,0-6.4l4.8-4.8c1.8-1.8,4.6-1.8,6.4,0\n\t\tc1.6,1.6,1.8,4,0.5,5.8",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M14.8,5.6l0.8-0.8c1.8-1.8,4.6-1.8,6.4,0s1.8,4.6,0,6.4l0,0L17.2,16c-1.8,1.8-4.6,1.8-6.4,0\n\t\tc-1.6-1.6-1.8-4-0.5-5.8",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }